import type { CountryIso3 } from "@/components/outreach/recruitment/panelPrediction/panelRegistry/countries";

export const BLOCKED_PANEL_COUNTRIES_ISO3: readonly CountryIso3[] = [
  "ARG", // Argentina
  "AUT", // Austria
  "BEL", // Belgium
  "BGR", // Bulgaria
  "CHE", // Switzerland
  "CHL", // Chile
  "CZE", // Czechia
  "DNK", // Denmark
  "FIN", // Finland
  "GRC", // Greece
  "JPN", // Japan
  "KOR", // South Korea
  "MYS", // Malaysia
  "NOR", // Norway
  "NZL", // New Zealand
  "PRI", // Puerto Rico
  "PRT", // Portugal
  "SGP", // Singapore
  "SVN", // Slovenia
  "SWE", // Sweden
];

export const isPanelCountryBlocked = ({
  countryIso3,
}: {
  countryIso3: CountryIso3;
}): boolean => BLOCKED_PANEL_COUNTRIES_ISO3.includes(countryIso3);
